export default "__VITE_ASSET__aAYRZu3J__"